// @ts-check
import { createSpatialIndex } from '../engine/spatial-index.js';
/** @typedef {import('./types.js').Solid} Solid */
/** @type {WeakMap<Solid[],ReturnType<typeof createSpatialIndex<Solid>>>} */
const indices = new WeakMap();

/** Static geometry is indexed once per level instance. Active flags remain live.
 * Replace the solids array when changing positions or adding geometry.
 * @param {import('./types.js').Level} level @param {number} left @param {number} right
 */
export function querySolids(level, left, right) {
  let index = indices.get(level.solids);
  if (!index) { index = createSpatialIndex(level.solids); indices.set(level.solids, index); }
  return [...index.query(left, right), ...level.dynamic.filter(solid => solid.x + solid.width >= left && solid.x <= right)].filter((solid) => solid.active);
}
